module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    ref: "btnForm",
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card', [_c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isNew),
      expression: "!isNew"
    }],
    attrs: {
      "column": ""
    }
  }, [_c('v-card-title', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('v-flex', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName))]), _vm._v(" "), (_vm.fileItem.signed) ? _c('v-flex', {
    staticClass: "caption"
  }, [_vm._v("Документ заверен, после загрузки новой версии необходимо снова заверить документ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [(_vm.isNew) ? _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.files), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: item.name,
      attrs: {
        "small": "",
        "text-color": _vm.errorFileMessage(item) ? 'error' : 'black',
        "close": ""
      },
      on: {
        "click": _vm.pickFile,
        "input": item.remove
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                  " + _vm._s(item.name.slice(0, 30)) + "\n                ")])])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorFileMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length === 0),
      expression: "files.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                Выбрать файл для депонирования\n                ")])]), _vm._v(" "), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.getAcceptedFileFormat(),
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 2)], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Название",
      "hint": "Название документа может не совпадать с именем файла",
      "disabled": _vm.files.length > 1,
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.docName),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "docName", $$v)
      },
      expression: "fileItem.docName"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Депонировать до:",
      "hint": "Дата, до которой файл доступен в депозитарии"
    },
    model: {
      value: (_vm.deleted),
      callback: function($$v) {
        _vm.deleted = $$v
      },
      expression: "deleted"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNew),
      expression: "isNew"
    }],
    attrs: {
      "label": "Примечания",
      "rows": "2",
      "hint": "Примечания видны только для пользователей депонента",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.desc),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "desc", $$v)
      },
      expression: "fileItem.desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNew),
      expression: "isNew"
    }],
    attrs: {
      "label": "Поисковые теги",
      "hint": "Поисковые теги используются для поиска по документам депонента",
      "rows": "1",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.tags),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "tags", $$v)
      },
      expression: "fileItem.tags"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_vm._v("\n          Депонировано: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.fileItem.uploaded, _vm.formats.formatDateTime)))]), _vm._v(" (по: " + _vm._s(_vm.formats.blank(_vm.fileItem.deleted, _vm.formats.formatDate)) + ")\n        ")]), _vm._v(" "), _c('v-flex', [_c('span', [_vm._v(" Депонент: "), _c('b', [_vm._v(_vm._s(_vm.fileItem.ownerShortName))]), _vm._v("\n           ИНН: "), _c('b', [_vm._v(_vm._s(_vm.formats.formatInn(_vm.fileItem.ownerInn)))])])]), _vm._v(" "), _c('v-flex', [_c('span', {
    staticClass: "caption"
  }, [_vm._v("Вы можете загрузить в депозитарий новую версию документа и использовать новую ссылку. Использование старой ссылки позволит видеть историю изменений. ")])]), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Название",
      "hint": "Название документа может не совпадать с именем файла",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.docName),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "docName", $$v)
      },
      expression: "fileItem.docName"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Депонировать до:",
      "hint": "Дата, до которой файл доступен в депозитарии"
    },
    model: {
      value: (_vm.deleted),
      callback: function($$v) {
        _vm.deleted = $$v
      },
      expression: "deleted"
    }
  })], 1), _vm._v(" "), _c('v-flex', [(!_vm.oldBody) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.files), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: item.name,
      attrs: {
        "small": "",
        "text-color": _vm.errorFileMessage(item) ? 'error' : 'black',
        "close": ""
      },
      on: {
        "click": _vm.pickFile,
        "input": item.remove
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                  " + _vm._s(item.name.slice(0, 30)) + "\n                ")])])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorFileMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length === 0),
      expression: "files.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                Выбрать файл для депонирования\n                ")])]), _vm._v(" "), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.getAcceptedFileFormat()
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-4": "",
      "pt-1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "не загружать файл",
      "persistent-hint": "",
      "color": "secondary",
      "hint": "Версия создается для изменения атрибутов"
    },
    model: {
      value: (_vm.oldBody),
      callback: function($$v) {
        _vm.oldBody = $$v
      },
      expression: "oldBody"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": _vm.disableUpload()
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("Загрузить")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f31dcf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/depo/DocNew.vue
// module id = 852
// module chunks = 1